module.exports = __webpack_public_path__ + "img/MESTNA OBCINA KOPER.9c3e86b4.png";